import styled from 'styled-components';
import Image from 'next/image';

type ContactContentProps = {
  src: string;
  alt: string;
  href: string;
  ariaLabel: string;
  description: string;
};

function ContactContent({
  description,
  ariaLabel,
  src,
  alt,
  href,
}: ContactContentProps) {
  return (
    <Wrapper>
      <StyledImage width={21} height={21} alt={alt} src={src} loading="lazy" />

      <Description href={href} aria-label={ariaLabel}>
        {description}
      </Description>
    </Wrapper>
  );
}

const Description = styled.a`
  font-size: 18px;
  font-weight: 600;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const StyledImage = styled(Image)`
  position: relative;
  margin-right: 7px;
  top: 1px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default ContactContent;
